var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "59575ce2ea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 46.554688 83.199219 L 328.554688 83.199219 L 328.554688 291.699219 L 46.554688 291.699219 Z M 46.554688 83.199219 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#59575ce2ea)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e52d27",
    d: "M 135.628906 144.066406 C 135.628906 137.855469 139.125 132.117188 144.546875 129.089844 C 149.964844 126.0625 156.679688 126.203125 161.96875 129.460938 L 231.226562 172.085938 C 236.335938 175.230469 239.402344 180.695312 239.402344 186.695312 C 239.402344 192.695312 236.359375 198.15625 231.25 201.300781 L 158.773438 245.933594 C 156.363281 247.417969 153.632812 248.164062 150.898438 248.164062 C 148.375 248.164062 145.726562 247.527344 143.449219 246.257812 C 138.703125 243.605469 135.628906 238.582031 135.628906 233.144531 Z M 98.953125 291.792969 L 276.34375 291.792969 C 305.09375 291.792969 328.4375 268.828125 328.4375 240.082031 L 328.4375 134.992188 C 328.4375 106.242188 305.09375 83.199219 276.34375 83.199219 L 98.953125 83.199219 C 70.207031 83.199219 46.554688 106.242188 46.554688 134.992188 L 46.554688 240.082031 C 46.554688 268.828125 70.207031 291.792969 98.953125 291.792969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.58bf6ca435bdc7e00ff2f61ca59102a4.svg";
export { ForwardRef as ReactComponent };